const E = {
  Welcome: 'Welcome',
  Home: 'Home',
  'Custom Reports': 'Custom Reports',
  Resources: 'Resources',
  'My Account': 'My Account',
  'Email Notifications': 'Email Notifications',
  'Manage Access': 'Manage Access',
  'Login as Admin': 'Login as Admin',
  Logout: 'Logout',
};

const F = {
  Welcome: 'Bienvenue',
  Home: 'Accueil',
  'Custom Reports': 'Rapports personnalisés',
  Resources: 'Ressources',
  'My Account': 'Mon compte',
  'Email Notifications': 'Notifications par courriel',
  'Manage Access': 'Gérer l’accès',
  'Login as Admin': 'Connectez-vous en tant qu\'administrateur',
  Logout: 'Déconnexion',
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/dash.js